import React from 'react';
import { Container, Label, LabelContainer } from './ControlStyles';

type Props = {
  label?: string;
  labelIcon?: any;
  children: any;
  direction?: string;
  style?: any;
  required?: boolean;
};

export const Control: React.FC<Props> = ({
  label,
  labelIcon,
  children,
  direction,
  required,
  style,
}) => {
  return (
    <Label style={style}>
      <LabelContainer>
        {required && <span>*</span>}
        {label || ' '}
        {labelIcon}
      </LabelContainer>
      <Container direction={direction ?? 'row'}>{children}</Container>
    </Label>
  );
};

export const TimeWindowControl: React.FC<Props> = ({
  label,
  children,
  direction,
  required,
  style,
}) => (
  <Label style={style}>
    <LabelContainer
      margin='5px 0 6px 0'
      fontWeight={500}
      fontSize='11px'
      color='#6E6E6E'
      theme=''
    >
      {required && <span>*</span>}
      {label || ' '}
    </LabelContainer>
    <Container direction={direction ?? 'row'}>{children}</Container>
  </Label>
);
